const _baseGoogleFonts = [
  { name: "Abel", format: "Abel" },
  { name: "Abril Fatface", format: "AbrilFatface" },
  { name: "Active Regular", format: "ActiveRegular" },
  { name: "Aleo Light", format: "AleoLight" },
  { name: "Aleo Light Italic", format: "AleoLightItalic" },
  { name: "Aleo Regular", format: "AleoRegular" },
  { name: "Aleo Italic", format: "AleoItalic" },
  { name: "Aleo Bold", format: "AleoBold" },
  { name: "Aleo Bold Italic", format: "AleoBoldItalic" },
  { name: "Alien Cyborg Italic", format: "AlienCyborgItalic" },
  { name: "Allan", format: "Allan" },
  { name: "Allan Bold", format: "AllanBold" },
  { name: "Anton", format: "Anton" },
  { name: "Archivo Thin", format: "ArchivoThin" },
  { name: "Archivo", format: "Archivo" },
  { name: "Archivo Bold", format: "ArchivoBold" },
  { name: "Archivo Black", format: "ArchivoBlack" },
  { name: "Arial", format: "Arial" },
  { name: "Arial Bold", format: "ArialBold" },
  { name: "Arimo", format: "Arimo" },
  { name: "Arimo Bold", format: "ArimoBold" },
  { name: "Arvo", format: "Arvo" },
  { name: "Arvo Bold", format: "ArvoBold" },
  { name: "Asap Thin", format: "AsapThin" },
  { name: "Asap", format: "Asap" },
  { name: "Asap Bold", format: "AsapBold" },
  { name: "Asap Black", format: "AsapBlack" },
  { name: "Avenir LT Std Book", format: "AvenirLTStdBook" },
  { name: "Avenir LT Std Roman", format: "AvenirLTStdRoman" },
  { name: "Avenir LT Std Black", format: "AvenirLTStdBlack" },
  { name: "Barlow Thin", format: "BarlowThin" },
  { name: "Barlow Light", format: "BarlowLight" },
  { name: "Barlow", format: "Barlow" },
  { name: "Barlow Medium", format: "BarlowMedium" },
  { name: "Barlow Semi Bold", format: "BarlowSemiBold" },
  { name: "Barlow Bold", format: "BarlowBold" },
  { name: "Barlow Black", format: "BarlowBlack" },
  { name: "Barlow Extra Bold", format: "BarlowExtraBold" },
  { name: "Barlow Condensed Thin", format: "BarlowCondensedThin" },
  { name: "Barlow Condensed Extra Light", format: "BarlowCondensedExtraLight" },
  { name: "Barlow Condensed Light", format: "BarlowCondensedLight" },
  { name: "Barlow Condensed", format: "BarlowCondensed" },
  { name: "Barlow Condensed Semi Bold", format: "BarlowCondensedSemiBold" },
  { name: "Barlow Condensed Bold", format: "BarlowCondensedBold" },
  { name: "Barlow Condensed Extra Bold", format: "BarlowCondensedExtraBold" },
  { name: "Barlow Condensed Black", format: "BarlowCondensedBlack" },
  { name: "Biennale Bold", format: "BiennaleBold" },
  { name: "Biennale Heavy", format: "BiennaleHeavy" },
  { name: "Biennale Light", format: "BiennaleLight" },
  { name: "Biennale Medium", format: "BiennaleMedium" },
  { name: "Biennale Regular", format: "BiennaleRegular" },
  { name: "Biennale BoldI talic", format: "BiennaleBoldItalic" },
  { name: "Biennale Heavy Italic", format: "BiennaleHeavyItalic" },
  { name: "Biennale Light Italic", format: "BiennaleLightItalic" },
  { name: "Biennale Medium Italic", format: "BiennaleMediumItalic" },
  { name: "Biennale Regular Italic", format: "BiennaleRegularItalic" },
  { name: "Bitter Light", format: "BitterLight" },
  { name: "Bitter", format: "Bitter" },
  { name: "Bitter Bold", format: "BitterBold" },
  { name: "Black Ops One", format: "BlackOpsOne" },
  { name: "Brandon Thin", format: "BrandonThin" },
  { name: "Brandon Light", format: "BrandonLight" },
  { name: "Brandon Regular", format: "BrandonRegular" },
  { name: "Brandon Medium", format: "BrandonMedium" },
  { name: "Brandon Bold", format: "BrandonBold" },
  { name: "Brandon Black", format: "BrandonBlack" },
  { name: "Bree Serif", format: "BreeSerif" },
  { name: "Cabin", format: "Cabin" },
  { name: "Cabin Bold", format: "CabinBold" },
  { name: "Calibri", format: "Calibri" },
  { name: "Calibri Bold", format: "CalibriBold" },
  { name: "Catamaran Thin", format: "CatamaranThin" },
  { name: "Catamaran", format: "Catamaran" },
  { name: "Catamaran Bold", format: "CatamaranBold" },
  { name: "Century Gothic", format: "CenturyGothic" },
  { name: "Century Gothic Bold", format: "CenturyGothicBold" },
  { name: "Chonburi", format: "Chonburi" },
  { name: "Claire Hand Regular", format: "ClaireHandRegular" },
  { name: "Cuprum", format: "Cuprum" },
  { name: "Cuprum Bold", format: "CuprumBold" },
  { name: "Dom Casual", format: "DomCasual" },
  { name: "Dom Casual Bold", format: "DomCasualBold" },
  {
    name: "Decade Black Condensed Ssi Black Condensed",
    format: "DecadeBlackCondensedSsiBlackCondensed",
  },
  { name: "DINOT Bold", format: "DINOTBold" },
  { name: "DINOT Medium", format: "DINOTMedium" },
  { name: "Dosis Light", format: "DosisLight" },
  { name: "Dosis", format: "Dosis" },
  { name: "Dosis Bold", format: "DosisBold" },
  { name: "Exo Light", format: "ExoLight" },
  { name: "Exo", format: "Exo" },
  { name: "Exo Bold", format: "ExoBold" },
  { name: "Exo Black", format: "ExoBlack" },
  { name: "Fakt Air", format: "FaktAir" },
  { name: "Fakt Hair", format: "FaktHair" },
  { name: "Fakt Thin", format: "FaktThin" },
  { name: "Fakt Light", format: "FaktLight" },
  { name: "Fakt", format: "Fakt" },
  { name: "Fakt Medium", format: "FaktMedium" },
  { name: "Fakt Semi Bold", format: "FaktSemiBold" },
  { name: "Fakt Bold", format: "FaktBold" },
  { name: "Fakt Black", format: "FaktBlack" },
  { name: "Fellix Thin", format: "FellixThin" },
  { name: "Fellix Light", format: "FellixLight" },
  { name: "Fellix Regular", format: "FellixRegular" },
  { name: "Fellix Medium", format: "FellixMedium" },
  { name: "Fellix Semi Bold", format: "FellixSemiBold" },
  { name: "Fellix Bold", format: "FellixBold" },
  { name: "Fellix Black", format: "FellixBlack" },
  { name: "Fira Sans Thin", format: "FiraSansThin" },
  { name: "Fira Sans", format: "FiraSans" },
  { name: "Fira Sans Bold", format: "FiraSansBold" },
  {
    name: "Fira Sans Condensed Regular",
    format: "FiraSansCondensedRegular",
  },
  { name: "Fjalla One", format: "FjallaOne" },
  { name: "Francois One", format: "FrancoisOne" },
  { name: "Fraunces Thin", format: "FrauncesThin" },
  { name: "Fraunces Light", format: "FrauncesLight" },
  { name: "Fraunces", format: "Fraunces" },
  { name: "Fraunces Bold", format: "FrauncesBold" },
  { name: "Fraunces Black", format: "FrauncesBlack" },
  { name: "Funnel Display Light", format: "FunnelDisplayLight" },
  { name: "Funnel Display", format: "FunnelDisplay" },
  { name: "Funnel Display Medium", format: "FunnelDisplayMedium" },
  { name: "Funnel Display Semi Bold", format: "FunnelDisplaySemiBold" },
  { name: "Funnel Display Bold", format: "FunnelDisplayBold" },
  { name: "Funnel Display Extra Bold", format: "FunnelDisplayExtraBold" },
  { name: "Funnel Sans Light", format: "FunnelSansLight" },
  { name: "Funnel Sans Light Italic", format: "FunnelSansLightItalic" },
  { name: "Funnel Sans", format: "FunnelSans" },
  { name: "Funnel Sans Italic", format: "FunnelSansItalic" },
  { name: "Funnel Sans Medium", format: "FunnelSansMedium" },
  { name: "Funnel Sans Medium Italic", format: "FunnelSansMediumItalic" },
  { name: "Funnel Sans Semi Bold", format: "FunnelSansSemiBold" },
  { name: "Funnel Sans Semi Bold Italic", format: "FunnelSansSemiBoldItalic" },
  { name: "Funnel Sans Bold", format: "FunnelSansBold" },
  { name: "Funnel Sans Bold Italic", format: "FunnelSansBoldItalic" },
  { name: "Funnel Sans Extra Bold", format: "FunnelSansExtraBold" },
  { name: "Funnel Sans Extra Bold Italic", format: "FunnelSansExtraBoldItalic" },
  { name: "Futura Bold", format: "FuturaBold" },
  { name: "Futura Medium", format: "FuturaMedium" },
  { name: "Futura Regular", format: "FuturaRegular" },
  { name: "Graphik Bold", format: "GraphikBold" },
  { name: "Graphik Regular", format: "GraphikRegular" },
  { name: "Graphik Semibold", format: "GraphikSemibold" },
  { name: "Great Vibes", format: "GreatVibes" },
  { name: "Grilled Cheese", format: "GrilledCheese" },
  { name: "Grilled Cheese Narrow", format: "GrilledCheeseBold" },
  { name: "Grilled Cheese Wide", format: "GrilledCheeseWide" },
  { name: "GT Super Display Bold", format: "GTSuperDisplayBold" },
  { name: "GT Super Text Book", format: "GTSuperTextBook" },
  { name: "Heebo Light", format: "HeeboLight" },
  { name: "Heebo", format: "Heebo" },
  { name: "Heebo Bold", format: "HeeboBold" },
  { name: "Helvetica Now Text ", format: "HelveticaNowText" },
  { name: "Helvetica Now Text Bold", format: "HelveticaNowTextBold" },
  { name: "Helvetica Now Text Light", format: "HelveticaNowTextLight" },
  { name: "Helvetica Now Text Medium", format: "HelveticaNowTextMedium" },
  { name: "Helvetica Now Text Italic", format: "HelveticaNowTextItalic" },
  {
    name: "Helvetica Now Text Bold Italic",
    format: "HelveticaNowTextBoldItalic",
  },
  {
    name: "Helvetica Now Text Light Italic",
    format: "HelveticaNowTextLightItalic",
  },
  {
    name: "Helvetica Now Text Medium Italic",
    format: "HelveticaNowTextMediumItalic",
  },
  { name: "Hind Light", format: "HindLight" },
  { name: "Hind", format: "Hind" },
  { name: "Hind Bold", format: "HindBold" },
  { name: "Inconsolata Light", format: "InconsolataLight" },
  { name: "Inconsolata", format: "Inconsolata" },
  { name: "Inconsolata Bold", format: "InconsolataBold" },
  { name: "Indie Flower", format: "IndieFlower" },
  { name: "Impact Label Reversed", format: "ImpactLabelReversed" },
  { name: "Inter Black", format: "InterBlack" },
  { name: "Inter Black Italic", format: "InterBlackItalic" },
  { name: "Inter Bold", format: "InterBold" },
  { name: "Inter Bold Italic", format: "InterBoldItalic" },
  { name: "Inter Extra Bold", format: "InterExtraBold" },
  { name: "Inter Extra Bold Italic", format: "InterExtraBoldItalic" },
  { name: "Inter Extra Light", format: "InterExtraLight" },
  { name: "Inter Extra Light Italic", format: "InterExtraLightItalic" },
  { name: "Inter Italic", format: "InterItalic" },
  { name: "Inter Light", format: "InterLight" },
  { name: "Inter Light Italic", format: "InterLightItalic" },
  { name: "Inter Medium", format: "InterMedium" },
  { name: "Inter Medium Italic", format: "InterMediumItalic" },
  { name: "Inter Regular", format: "InterRegular" },
  { name: "Inter Semi Bold", format: "InterSemiBold" },
  { name: "Inter Semi Bold Italic", format: "InterSemiBoldItalic" },
  { name: "Inter Thin", format: "InterThin" },
  { name: "Inter Thin Italic", format: "InterThinItalic" },
  { name: "Josefin Sans Light", format: "JosefinSansLight" },
  { name: "Josefin Sans", format: "JosefinSans" },
  { name: "Josefin Sans Bold", format: "JosefinSansBold" },
  { name: "Jost Semi Bold", format: "JostSemiBold" },
  { name: "Karla", format: "Karla" },
  { name: "Kaushan Script", format: "KaushanScript" },
  { name: "Lato", format: "Lato" },
  { name: "Lato Black", format: "LatoBlack" },
  { name: "Lato Black Italic", format: "LatoBlackItalic" },
  { name: "Lato Bold", format: "LatoBold" },
  { name: "Lato Bold Italic", format: "LatoBoldItalic" },
  { name: "Lato Hairline", format: "LatoHairline" },
  { name: "Lato Hairline Italic", format: "LatoHairlineItalic" },
  { name: "Lato Heavy", format: "LatoHeavy" },
  { name: "Lato Heavy Italic", format: "LatoHeavyItalic" },
  { name: "Lato Italic", format: "LatoItalic" },
  { name: "Lato Light", format: "LatoLight" },
  { name: "Lato Light Italic", format: "LatoLightItalic" },
  { name: "Lato Medium", format: "LatoMedium" },
  { name: "Lato Medium Italic", format: "LatoMediumItalic" },
  { name: "Lato Regular", format: "LatoRegular" },
  { name: "Lato Semibold", format: "LatoSemibold" },
  { name: "Lato Semibold Italic", format: "LatoSemiboldItalic" },
  { name: "Lato Thin", format: "LatoThin" },
  { name: "Lato Thin Italic", format: "LatoThinItalic" },
  { name: "Libre Baskerville", format: "LibreBaskerville" },
  { name: "Libre Baskerville Bold", format: "LibreBaskervilleBold" },
  { name: "Libre Franklin Light", format: "LibreFranklinLight" },
  { name: "Libre Franklin", format: "LibreFranklin" },
  { name: "Libre Franklin Bold", format: "LibreFranklinBold" },
  { name: "Libre Franklin Black", format: "LibreFranklinBlack" },
  { name: "Linik Sans Thin", format: "LinikSansThin" },
  { name: "Linik Sans Extra Light", format: "LinikSansExtraLight" },
  { name: "Linik Sans Light", format: "LinikSansLight" },
  { name: "Linik Sans", format: "LinikSansRegular" },
  { name: "Linik Sans Medium", format: "LinikSansMedium" },
  { name: "Linik Sans Semi Bold", format: "LinikSansSemiBold" },
  { name: "Linik Sans Bold", format: "LinikSansBold" },
  { name: "Linik Sans Extra Bold", format: "LinikSansExtraBold" },
  { name: "Linik Sans Black", format: "LinikSansBlack" },
  { name: "Lobster", format: "Lobster" },
  { name: "Lora", format: "Lora" },
  { name: "Louize", format: "Louize" },
  { name: "Louize Bold", format: "LouizeBold" },
  { name: "Luckiest Guy", format: "LuckiestGuy" },
  { name: "Marcellus SC", format: "MarcellusSC" },
  { name: "Maven Pro", format: "MavenPro" },
  { name: "Maven Pro Bold", format: "MavenProBold" },
  { name: "Maven Pro Black", format: "MavenProBlack" },
  { name: "Meister Bold", format: "MeisterBold" },
  { name: "Merriweather Light", format: "MerriweatherLight" },
  { name: "Merriweather", format: "Merriweather" },
  { name: "Merriweather Bold", format: "MerriweatherBold" },
  { name: "Merriweather Black", format: "MerriweatherBlack" },
  { name: "Messina Sans Regular", format: "MessinaSansRegular" },
  { name: "Messina Sans SemiBold", format: "MessinaSansSemiBold" },
  { name: "Messina Sans Bold", format: "MessinaSansBold" },
  { name: "Messina Sans Mono Regular", format: "MessinaSansMonoRegular" },
  { name: "Monoton", format: "Monoton" },
  { name: "Montserrat Light", format: "MontserratLight" },
  { name: "Montserrat", format: "Montserrat" },
  { name: "Montserrat Bold", format: "MontserratBold" },
  { name: "Montserrat Black", format: "MontserratBlack" },
  { name: "Mukta Light", format: "MuktaLight" },
  { name: "Mukta", format: "Mukta" },
  { name: "Muli", format: "MuliRegular" },
  { name: "Muli Bold", format: "MuliBold" },
  { name: "Muli Light", format: "MuliLight" },
  { name: "Mukta Bold", format: "MuktaBold" },
  { name: "Nanum Gothic", format: "NanumGothic" },
  { name: "Nanum Gothic Bold", format: "NanumGothicBold" },
  { name: "Neue Haas Unica", format: "NeueHaasUnica" },
  { name: "Neue Haas Unica Bold", format: "NeueHaasUnicaBold" },
  { name: "Neue Haas Unica Extra Bold", format: "NeueHaasUnicaExtraBold" },
  { name: "Noe Display", format: "NoeDisplay" },
  { name: "Noe Display Italic", format: "NoeDisplayItalic" },
  { name: "Noe Display Medium", format: "NoeDisplayMedium" },
  { name: "Noe Display Medium Italic", format: "NoeDisplayMediumItalic" },
  { name: "Noe Display Bold", format: "NoeDisplayBold" },
  { name: "Noe Display Bold Italic", format: "NoeDisplayBoldItalic" },
  { name: "Noe Display Black", format: "NoeDisplayBlack" },
  { name: "Noe Display Black Italic", format: "NoeDisplayBlackItalic" },
  { name: "Noe Text", format: "NoeText" },
  { name: "Noe Text Italic", format: "NoeTextItalic" },
  { name: "Noe Text Book", format: "NoeTextBook" },
  { name: "Noe Text Book Italic", format: "NoeTextBookItalic" },
  { name: "Noe Text Semi Bold", format: "NoeTextSemiBold" },
  { name: "Noe Text Semi Bold Italic", format: "NoeTextSemiBoldItalic" },
  { name: "Noe Text Bold", format: "NoeTextBold" },
  { name: "Noe Text Bold Italic", format: "NoeTextBoldItalic" },
  { name: "Noe Text Black", format: "NoeTextBlack" },
  { name: "Noe Text Black Italic", format: "NoeTextBlackItalic" },
  { name: "Noto Sans Light", format: "NotoSansLight" },
  { name: "Noto Sans", format: "NotoSans" },
  { name: "Noto Sans Bold", format: "NotoSansBold" },
  { name: "Noto Sans Black", format: "NotoSansBlack" },
  { name: "Nunito Light", format: "NunitoLight" },
  { name: "Nunito", format: "Nunito" },
  { name: "Nunito Bold", format: "NunitoBold" },
  { name: "Nunito Black", format: "NunitoBlack" },
  { name: "Ollies Solid", format: "OlliesSolid" },
  { name: "Open Sans Light", format: "OpenSansLight" },
  { name: "Open Sans", format: "OpenSans" },
  { name: "Open Sans Semi Bold", format: "OpenSansSemiBold" },
  { name: "Open Sans Bold", format: "OpenSansBold" },
  { name: "Open Sans Extra Bold", format: "OpenSansExtraBold" },
  { name: "Oswald Light", format: "OswaldLight" },
  { name: "Oswald", format: "Oswald" },
  { name: "Oswald Bold", format: "OswaldBold" },
  { name: "Oxygen Light", format: "OxygenLight" },
  { name: "Oxygen", format: "Oxygen" },
  { name: "Oxygen Bold", format: "OxygenBold" },
  { name: "Passions Conflict", format: "PassionsConflict" },
  {
    name: "Pathway Gothic One Regular",
    format: "PathwayGothicOneRegular",
  },
  {
    name: "Pathways Rough Regular",
    format: "PathwaysRoughRegular",
  },
  {
    name: "Permanent Marker Regular",
    format: "PermanentMarkerRegular",
  },
  { name: "Pilat Thin", format: "PilatThin" },
  { name: "Pilat Light", format: "PilatLight" },
  { name: "Pilat", format: "Pilat" },
  { name: "Pilat Book", format: "PilatBook" },
  { name: "Pilat Demi", format: "PilatDemi" },
  { name: "Pilat Bold", format: "PilatBold" },
  { name: "Pilat Heavy", format: "PilatHeavy" },
  { name: "Pilat Black", format: "PilatBlack" },
  { name: "Pilat Extended Thin", format: "PilatExtendedThin" },
  { name: "Pilat Extended Light", format: "PilatExtendedLight" },
  { name: "Pilat Extended", format: "PilatExtended" },
  { name: "Pilat Extended Book", format: "PilatExtendedBook" },
  { name: "Pilat Extended Demi", format: "PilatExtendedDemi" },
  { name: "Pilat Extended Bold", format: "PilatExtendedBold" },
  { name: "Pilat Extended Heavy", format: "PilatExtendedHeavy" },
  { name: "Pilat Extended Black", format: "PilatExtendedBlack" },
  { name: "Pilat Narrow Book", format: "PilatNarrowBook" },
  { name: "Pilat Narrow Bold", format: "PilatNarrowBold" },
  { name: "Pilat Narrow Black", format: "PilatNarrowBlack" },
  {
    name: "Pipetton Script",
    format: "PipettonScript",
  },
  { name: "PT Sans", format: "PTSans" },
  { name: "PT Sans Bold", format: "PTSansBold" },
  { name: "PT Serif", format: "PTSerif" },
  { name: "PT Serif Bold", format: "PTSerifBold" },
  { name: "Pacifico", format: "Pacifico" },
  { name: "Playfair Display SC", format: "PlayfairDisplaySC" },
  { name: "Playfair Display SC Bold", format: "PlayfairDisplaySCBold" },
  { name: "Playfair Display SC Black", format: "PlayfairDisplaySCBlack" },
  { name: "Poppins", format: "Poppins" },
  { name: "Porsche Next TT Thin", format: "PorscheNextTTThin" },
  { name: "Porsche Next TT Regular", format: "PorscheNextTTRegular" },
  { name: "Porsche Next TT Bold", format: "PorscheNextTTBold" },
  { name: "Primark Basis Regular", format: "PrimarkBasisRegular" },
  { name: "Primark Basis Bold", format: "PrimarkBasisBold" },
  { name: "Proxima Nova", format: "ProximaNova" },
  { name: "Proxima Nova Bold", format: "ProximaNovaBold" },
  { name: "Prosto One", format: "ProstoOne" },
  { name: "Questrial Regular", format: "QuestrialRegular" },
  { name: "Quicksand", format: "Quicksand" },
  { name: "Raleway Thin", format: "RalewayThin" },
  { name: "Raleway Extra Light", format: "RalewayExtraLight" },
  { name: "Raleway Light", format: "RalewayLight" },
  { name: "Raleway", format: "Raleway" },
  { name: "Raleway Medium", format: "RalewayMedium" },
  { name: "Raleway Semi Bold", format: "RalewaySemiBold" },
  { name: "Raleway Bold", format: "RalewayBold" },
  { name: "Raleway Extra Bold", format: "RalewayExtraBold" },
  { name: "Raleway Dots", format: "RalewayDots" },
  { name: "Roboto Thin", format: "RobotoThin" },
  { name: "Roboto", format: "Roboto" },
  { name: "Roboto Bold", format: "RobotoBold" },
  { name: "Roboto Black", format: "RobotoBlack" },
  { name: "Roboto Condensed Light", format: "RobotoCondensedLight" },
  { name: "Roboto Condensed", format: "RobotoCondensed" },
  { name: "Roboto Condensed Bold", format: "RobotoCondensedBold" },
  { name: "Roboto Slab Bold", format: "RobotoSlabBold" },
  { name: "Roboto Slab Light", format: "RobotoSlabLight" },
  { name: "Roboto Slab Regular", format: "RobotoSlabRegular" },
  { name: "Roboto Slab Thin", format: "RobotoSlabThin" },
  { name: "Rokkitt Light", format: "RokkittLight" },
  { name: "Rokkitt", format: "Rokkitt" },
  { name: "Rokkitt Bold", format: "RokkittBold" },
  { name: "Rokkitt Black", format: "RokkittBlack" },
  { name: "Rubik", format: "Rubik" },
  { name: "Rubik Vinyl", format: "RubikVinyl" },
  { name: "Rubik Gemstones", format: "RubikGemstones" },
  { name: "Rubik Glitch", format: "RubikGlitch" },
  { name: "Rubik Microbe", format: "RubikMicrobe" },
  { name: "Rubik Moonrocks", format: "RubikMoonrocks" },
  { name: "Rubik Wet Paint", format: "RubikWetPaint" },
  { name: "Rund", format: "Rund" },
  { name: "Rund Medium", format: "RundMedium" },
  { name: "Rund Black", format: "RundBlack" },
  { name: "Rund Extra Bold", format: "RundExtraBold" },
  { name: "Roobert", format: "Roobert" },
  { name: "Sevillana", format: "Sevillana" },
  { name: "Shantell Sans Extra Bold", format: "ShantellSansExtraBold" },
  { name: "Shantell Sans Medium", format: "ShantellSansMedium" },
  { name: "Shadows Into Light", format: "ShadowsIntoLight" },
  { name: "Signika", format: "Signika" },
  { name: "Slabo 27px", format: "Slabo27px" },
  { name: "Sofia Pro Bold", format: "SofiaProBold" },
  { name: "Sohne Thin", format: "SohneThin" },
  { name: "Sohne Light", format: "SohneLight" },
  { name: "Sohne", format: "Sohne" },
  { name: "Sohne Medium", format: "SohneMedium" },
  { name: "Sohne Semi Bold", format: "SohneSemiBold" },
  { name: "Sohne Bold", format: "SohneBold" },
  { name: "Sohne Extra Bold", format: "SohneExtraBold" },
  { name: "Sohne Black", format: "SohneBlack" },
  { name: "Sohne Mono", format: "SohneMono" },
  { name: "Sohne Mono Medium", format: "SohneMonoMedium" },
  { name: "Source Code Pro Light", format: "SourceCodeProLight" },
  { name: "Source Code Pro", format: "SourceCodePro" },
  { name: "Source Code Pro Bold", format: "SourceCodeProBold" },
  { name: "Source Sans Pro Light", format: "SourceSansProLight" },
  { name: "Source Sans Pro", format: "SourceSansPro" },
  { name: "Source Sans Pro Bold", format: "SourceSansProBold" },
  { name: "Swear Display Regular", format: "SwearDisplayRegular" },
  { name: "Tekton Light", format: "TektonLight" },
  { name: "Tekton", format: "Tekton" },
  { name: "Tekton Bold", format: "TektonBold" },
  { name: "Termina Test Bold", format: "TerminaTestBold" },
  { name: "Termina Test Regular", format: "TerminaTestRegular" },
  { name: "Tiempos Headline Light", format: "TiemposHeadlineLight" },
  { name: "Tiempos Headline Semibold", format: "TiemposHeadlineSemibold" },
  {
    name: "Tiempos Headline SemiboldItalic",
    format: "TiemposHeadlineSemiboldItalic",
  },
  { name: "Titillium Web Light", format: "TitilliumWebLight" },
  { name: "Titillium Web", format: "TitilliumWeb" },
  { name: "Titillium Web Bold", format: "TitilliumWebBold" },
  { name: "Titillium Web Black", format: "TitilliumWebBlack" },
  { name: "Trade Gothic Light", format: "Trade Gothic Light" },
  { name: "Trade Gothic", format: "Trade Gothic" },
  { name: "Trade Gothic Bold", format: "Trade Gothic Bold" },
  {
    name: "Trade Gothic Bold Condensed",
    format: "Trade Gothic Bold Condensed",
  },
  { name: "Ubuntu Light", format: "UbuntuLight" },
  { name: "Ubuntu", format: "Ubuntu" },
  { name: "Ubuntu Medium", format: "UbuntuMedium" },
  { name: "Ubuntu Bold", format: "UbuntuBold" },
  { name: "Varela Round", format: "VarelaRound" },
  { name: "Vollkorn", format: "Vollkorn" },
  { name: "Vollkorn Bold", format: "VollkornBold" },
  { name: "Whitney", format: "Whitney" },
  { name: "Whitney Light", format: "WhitneyLight" },
  { name: "Whitney Medium", format: "WhitneyMedium" },
  { name: "Whitney Book", format: "WhitneyBook" },
  { name: "Whitney Semi Bold", format: "WhitneySemiBold" },
  { name: "Whitney Bold", format: "WhitneyBold" },
  { name: "Whitney Black", format: "WhitneyBlack" },
  { name: "Work Sans Light", format: "WorkSansLight" },
  { name: "Work Sans", format: "WorkSans" },
  { name: "Work Sans Bold", format: "WorkSansBold" },
  { name: "Yanone Kaffeesatz Light", format: "YanoneKaffeesatzLight" },
  { name: "Yanone Kaffeesatz", format: "YanoneKaffeesatz" },
  { name: "Yanone Kaffeesatz Bold", format: "YanoneKaffeesatzBold" },
  { name: "Yorkten Slab", format: "YorktenSlab" },
  { name: "Zodiak Thin", format: "ZodiakThin" },
  { name: "Zodiak Light", format: "ZodiakLight" },
  { name: "Zodiak", format: "Zodiak" },
  { name: "Zodiak Bold", format: "ZodiakBold" },
  { name: "Zodiak Extra Bold", format: "ZodiakExtraBold" },
  { name: "Zodiak Black", format: "ZodiakBlack" },
];

const _baseGoogleFontsEditor =
  "Abel='Abel', sans-serif;" +
  "Abril Fatface='AbrilFatface', sans-serif;" +
  "Active Regular='ActiveRegular', sans-serif;" +
  "Aleo Light='AleoLight', sans-serif;" +
  "Aleo Light Italic='AleoLightItalic', sans-serif;" +
  "Aleo Regular='AleoRegular', sans-serif;" +
  "Aleo Italic='AleoItalic', sans-serif;" +
  "Aleo Bold='AleoBold', sans-serif;" +
  "Aleo Bold Italic='AleoBoldItalic', sans-serif;" +
  "Alien Cyborg Italic='AlienCyborgItalic', sans-serif;" +
  "Allan='Allan', sans-serif;" +
  "Allan Bold='AllanBold', sans-serif;" +
  "Anton='Anton', sans-serif;" +
  "Archivo Thin='ArchivoThin', sans-serif;" +
  "Archivo='Archivo', sans-serif;" +
  "Archivo Bold='ArchivoBold', sans-serif;" +
  "Archivo Black='ArchivoBlack', sans-serif;" +
  "Arial='Arial', sans-serif;" +
  "Arial Bold='ArialBold', sans-serif;" +
  "Arimo='Arimo', sans-serif;" +
  "Arimo Bold='ArimoBold', sans-serif;" +
  "Arvo='Arvo', serif;" +
  "Arvo Bold='ArvoBold', serif;" +
  "Asap Thin='AsapThin', sans-serif;" +
  "Asap='Asap', sans-serif;" +
  "Asap Bold='AsapBold;" +
  "Asap Black='AsapBlack', sans-serif;" +
  "Avenir LT Std Book='AvenirLTStdBook';" +
  "Avenir LT Std Roman='AvenirLTStdRoman';" +
  "Avenir LT Std Black='AvenirLTStdBlack';" +
  "Barlow Thin='BarlowThin';" +
  "Barlow Light='BarlowLight';" +
  "Barlow='Barlow';" +
  "Barlow Medium='BarlowMedium';" +
  "Barlow Semi Bold='BarlowSemiBold';" +
  "Barlow Bold='BarlowBold';" +
  "Barlow Extra Bold='BarlowExtraBold';" +
  "Barlow Black='BarlowBlack';" +
  "Barlow Condensed Thin='BarlowCondensedThin';" +
  "Barlow Condensed Extra Light='BarlowCondensedExtraLight';" +
  "Barlow Condensed Light='BarlowCondensedLight';" +
  "Barlow Condensed='BarlowCondensed';" +
  "Barlow Condensed Semi Bold='BarlowCondensedSemiBold';" +
  "Barlow Condensed Bold='BarlowCondensedBold';" +
  "Barlow Condensed Extra Bold='BarlowCondensedExtraBold';" +
  "Barlow Condensed Black='BarlowCondensedBlack';" +
  "Biennale Bold ='BiennaleBold';" +
  "Biennale Heavy ='BiennaleHeavy';" +
  "Biennale Light ='BiennaleLight';" +
  "Biennale Medium ='BiennaleMedium';" +
  "Biennale Regular ='BiennaleRegular';" +
  "Biennale Bold Italic='BiennaleBoldItalic';" +
  "Biennale Heavy Italic='BiennaleHeavyItalic';" +
  "Biennale Light Italic='BiennaleLightItalic';" +
  "Biennale Medium Italic='BiennaleMediumItalic';" +
  "Biennale Regular Italic='BiennaleRegularItalic';" +
  "Bitter Light='BitterLight', serif;" +
  "Bitter='Bitter', serif;" +
  "Bitter Bold='BitterBold', serif;" +
  "Black Ops One='BlackOpsOne',cursive;" +
  "Brandon Thin='BrandonThin',serif;" +
  "Brandon Light='BrandonLight',serif;" +
  "Brandon Regular='BrandonRegular',serif;" +
  "Brandon Mediuim='BrandonMedium',serif;" +
  "Brandon Bold='BrandonBold',serif;" +
  "Brandon Black='BrandonBlack',serif;" +
  "Bree Serif='BreeSerif', serif;" +
  "Cabin='Cabin', sans-serif;" +
  "Cabin Bold='CabinBold', sans-serif;" +
  "Calibri='Calibri',sans-serif;" +
  "Calibri Bold ='CalibriBold',sans-serif;" +
  "Catamaran Thin='CatamaranThin', sans-serif;" +
  "Catamaran='Catamaran', sans-serif;" +
  "Catamaran Bold='CatamaranBold', sans-serif;" +
  "Chonburi='Chonburi',cursive;" +
  "Century Gothic='CenturyGothic',serif;" +
  "Century Gothic Bold='CenturyGothicBold',serif;" +
  "Claire Hand Regular='ClaireHandRegular', sans-serif;" +
  "Cuprum='Cuprum', sans-serif;" +
  "Cuprum Bold='CuprumBold', sans-serif;" +
  "Dom Casual='DomCasual',sans-serif;" +
  "Dom Casual Bold='DomCasualBold',sans-serif;" +
  "Decade Black Condensed Ssi Black Condensed='DecadeBlackCondensedSsiBlackCondensed', sans-serif;" +
  "DINOT Bold='DINOTBold', sans-serif;" +
  "DINOT Medium='DINOTMedium', sans-serif;" +
  "Dosis Light='DosisLight', sans-serif;" +
  "Dosis='Dosis', sans-serif;" +
  "Dosis Bold='DosisBold', sans-serif;" +
  "Exo Light='ExoLight', sans-serif;" +
  "Exo='Exo', sans-serif;" +
  "Exo Bold='ExoBold', sans-serif;" +
  "Exo Black='ExoBlack', sans-serif;" +
  "Fakt Air='FaktAir', sans-serif;" +
  "Fakt Hair='FaktHair', sans-serif;" +
  "Fakt Thin='FaktThin', sans-serif;" +
  "Fakt Light='FaktLight', sans-serif;" +
  "Fakt='Fakt', sans-serif;" +
  "Fakt Medium='FaktMedium', sans-serif;" +
  "Fakt Semi Bold='FaktSemiBold', sans-serif;" +
  "Fakt Bold='FaktBold', sans-serif;" +
  "Fakt Black='FaktBlack', sans-serif;" +
  "Fellix Thin='FellixThin', sans-serif;" +
  "Fellix Light='FellixLight', sans-serif;" +
  "Fellix Regular='FellixRegular', sans-serif;" +
  "Fellix Medium='FellixMedium', sans-serif;" +
  "Fellix Semi Bold='FellixSemiBold', sans-serif;" +
  "Fellix Bold='FellixBold', sans-serif;" +
  "Fellix Black='FellixBlack', sans-serif;" +
  "Fira Sans Thin='FiraSansThin', sans-serif;" +
  "Fira Sans='FiraSans', sans-serif;" +
  "Fira Sans Bold='FiraSansBold', sans-serif;" +
  "Fira Sans Condensed Regular='FiraSansCondensedRegular', sans-serif;" +
  "Fjalla One='FjallaOne', sans-serif;" +
  "Francois One='FrancoisOne', sans-serif;" +
  "Fraunces Thin='FrauncesThin', sans-serif;" +
  "Fraunces Light='FrauncesLight', sans-serif;" +
  "Fraunces='Fraunces', sans-serif;" +
  "Fraunces Bold='FrauncesBold', sans-serif;" +
  "Fraunces Black='FrauncesBlack', sans-serif;" +
  "Funnel Display Light='FunnelDisplayLight', sans-serif;" +
  "Funnel Display='FunnelDisplay', sans-serif;" +
  "Funnel Display Medium='FunnelDisplayMedium', sans-serif;" +
  "Funnel Display Semi Bold='FunnelDisplaySemiBold', sans-serif;" +
  "Funnel Display Bold='FunnelDisplayBold', sans-serif;" +
  "Funnel Display Extra Bold='FunnelDisplayExtraBold', sans-serif;" +
  "Funnel Sans Light='FunnelSansLight', sans-serif;" +
  "Funnel Sans Light Italic='FunnelSansLightItalic', sans-serif;" +
  "Funnel Sans='FunnelSans', sans-serif;" +
  "Funnel Sans Italic='FunnelSansItalic', sans-serif;" +
  "Funnel Sans Medium='FunnelSansMedium', sans-serif;" +
  "Funnel Sans Medium Italic='FunnelSansMediumItalic', sans-serif;" +
  "Funnel Sans Semi Bold='FunnelSansSemiBold', sans-serif;" +
  "Funnel Sans Semi Bold Italic='FunnelSansSemiBoldItalic', sans-serif;" +
  "Funnel Sans Bold='FunnelSansBold', sans-serif;" +
  "Funnel Sans Bold Italic='FunnelSansBoldItalic', sans-serif;" +
  "Funnel Sans Extra Bold='FunnelSansExtraBold', sans-serif;" +
  "Funnel Sans Extra Bold Italic='FunnelSansExtraBoldItalic', sans-serif;" +
  "Futura Bold='FuturaBold', sans-serif;" +
  "Futura Medium='FuturaMedium', sans-serif;" +
  "Futura Regular='FuturaRegular', sans-serif;" +
  "Graphik Bold='GraphikBold', sans-serif;" +
  "Graphik Regular='GraphikRegular', sans-serif;" +
  "Graphik Semibold='GraphikSemibold', sans-serif;" +
  "Grilled Cheese='GrilledCheese',sans-serif;" +
  "Grilled Cheese Narrow='GrilledCheeseBold',sans-serif;" +
  "Grilled Cheese Wide='GrilledCheeseWide',sans-serif;" +
  "Great Vibes='GreatVibes', cursive;" +
  "GT Super Display Bold='GTSuperDisplayBold', sans-serif;" +
  "GT Super Text Book='GTSuperTextBook', sans-serif;" +
  "Heebo Light='HeeboLight', sans-serif;" +
  "Heebo='Heebo', sans-serif;" +
  "Heebo Bold='HeeboBold', sans-serif;" +
  "Helvetica Now Text ='HelveticaNowText', sans-serif;" +
  "Helvetica Now Text Bold='HelveticaNowTextBold', sans-serif;" +
  "Helvetica Now Text Light='HelveticaNowTextLight', sans-serif;" +
  "Helvetica Now Text Medium='HelveticaNowTextMedium', sans-serif;" +
  "Helvetica Now Text Italic='HelveticaNowTextItalic', sans-serif;" +
  "Helvetica Now Text Bold Italic='HelveticaNowTextBoldItalic', sans-serif;" +
  "Helvetica Now Text Light Italic='HelveticaNowTextLightItalic', sans-serif;" +
  "Helvetica Now Text Medium Italic='HelveticaNowTextMediumItalic', sans-serif;" +
  "Hind Light='HindLight', sans-serif;" +
  "Hind='Hind', sans-serif;" +
  "Hind Bold='HindBold', sans-serif;" +
  "Inconsolata Light='InconsolataLight', monospace;" +
  "Inconsolata='Inconsolata', monospace;" +
  "Inconsolata Bold='InconsolataBold', monospace;" +
  "Indie Flower='IndieFlower', cursive;" +
  "Impact Label Reversed='ImpactLabelReversed', sans-serif;" +
  "Inter Black='InterBlack', sans-serif;" +
  "Inter Black Italic='InterBlackItalic', sans-serif;" +
  "Inter Bold='InterBold', sans-serif;" +
  "Inter Bold Italic='InterBoldItalic', sans-serif;" +
  "Inter Extra Bold='InterExtraBold', sans-serif;" +
  "Inter Extra Bold Italic='InterExtraBoldItalic', sans-serif;" +
  "Inter Extra Light='InterExtraLight', sans-serif;" +
  "Inter Extra Light Italic='InterExtraLightItalic', sans-serif;" +
  "Inter Italic='InterItalic', sans-serif;" +
  "Inter Light='InterLight', sans-serif;" +
  "Inter Light Italic='InterLightItalic', sans-serif;" +
  "Inter Medium='InterMedium', sans-serif;" +
  "Inter Medium Italic='InterMediumItalic', sans-serif;" +
  "Inter Regular='InterRegular', sans-serif;" +
  "Inter Semi Bold='InterSemiBold', sans-serif;" +
  "Inter Semi Bold Italic='InterSemiBoldItalic', sans-serif;" +
  "Inter Thin='InterThin', sans-serif;" +
  "Inter Thin Italic='InterThinItalic', sans-serif;" +
  "Josefin Sans Light='JosefinSansLight', sans-serif;" +
  "Josefin Sans='JosefinSans', sans-serif;" +
  "Josefin Sans Bold='JosefinSansBold', sans-serif;" +
  "Jost Semi Bold='JostSemiBold', sans-serif;" +
  "Karla='Karla', sans-serif;" +
  "Kaushan Script='KaushanScript',cursive;" +
  "Lato='Lato', sans-serif;" +
  "Lato Black='LatoBlack', sans-serif;" +
  "Lato BlackItalic='LatoBlackItalic', sans-serif;" +
  "Lato Bold='LatoBold', sans-serif;" +
  "Lato BoldItalic='LatoBoldItalic', sans-serif;" +
  "Lato Hairline='LatoHairline', sans-serif;" +
  "Lato HairlineItalic='LatoHairlineItalic', sans-serif;" +
  "Lato Heavy='LatoHeavy', sans-serif;" +
  "Lato HeavyItalic='LatoHeavyItalic', sans-serif;" +
  "Lato Italic='LatoItalic', sans-serif;" +
  "Lato Light='LatoLight', sans-serif;" +
  "Lato LightItalic='LatoLightItalic', sans-serif;" +
  "Lato Medium='LatoMedium', sans-serif;" +
  "Lato MediumItalic='LatoMediumItalic', sans-serif;" +
  "Lato Regular='LatoRegular', sans-serif;" +
  "Lato Semibold='LatoSemibold', sans-serif;" +
  "Lato SemiboldItalic='LatoSemiboldItalic', sans-serif;" +
  "Lato Thin='LatoThin', sans-serif;" +
  "Lato ThinItalic='LatoThinItalic', sans-serif;" +
  "Libre Baskerville='LibreBaskerville', serif;" +
  "Libre Baskerville Bold='LibreBaskervilleBold', serif;" +
  "Libre Franklin Light='LibreFranklinLight', sans-serif;" +
  "Libre Franklin='LibreFranklin', sans-serif;" +
  "Libre Franklin Bold='LibreFranklinBold', sans-serif;" +
  "Libre Franklin Black='LibreFranklinBlack', sans-serif;" +
  "Linik Sans Thin='LinikSansThin', sans-serif;" +
  "Linik Sans Extra Light='LinikSansExtraLight', sans-serif;" +
  "Linik Sans Light='LinikSansLight', sans-serif;" +
  "Linik Sans='LinikSansRegular', sans-serif;" +
  "Linik Sans Medium='LinikSansMedium', sans-serif;" +
  "Linik Sans Semi Bold='LinikSansSemiBold', sans-serif;" +
  "Linik Sans Bold='LinikSansBold', sans-serif;" +
  "Linik Sans Extra Bold='LinikSansExtraBold', sans-serif;" +
  "Linik Sans Black='LinikSansBlack', sans-serif;" +
  "Lobster='Lobster', cursive;" +
  "Lora='Lora', serif;" +
  "Louize='Louize', serif;" +
  "Louize Bold='LouizeBold', serif;" +
  "Luckiest Guy='LuckiestGuy',sans-serif;" +
  "Marcellus SC='MarcellusSC',serif;" +
  "Maven Pro='MavenPro', sans-serif;" +
  "Maven Pro Bold='MavenProBold', sans-serif;" +
  "Maven Pro Black='MavenProBlack', sans-serif;" +
  "Meister Bold='MeisterBold', sans-serif;" +
  "Merriweather Light='MerriweatherLight', serif;" +
  "Merriweather='Merriweather', serif;" +
  "Merriweather Bold='MerriweatherBold', serif;" +
  "Merriweather Black='MerriweatherBlack', serif;" +
  "Messina Sans Regular='MessinaSansRegular', serif;" +
  "Messina Sans SemiBold='MessinaSansSemiBold', serif;" +
  "Messina Sans Bold='MessinaSansBold', serif;" +
  "Messina Sans Mono Regular='MessinaSansMonoRegular', serif;" +
  "Monoton='Monoton', Montserrat;" +
  "Montserrat Light='MontserratLight', sans-serif;" +
  "Montserrat='Montserrat', sans-serif;" +
  "Montserrat Bold='MontserratBold', sans-serif;" +
  "Montserrat Black='MontserratBlack', sans-serif;" +
  "Mukta Light='MuktaLight', sans-serif;" +
  "Mukta='Mukta', sans-serif;" +
  "Mukta Bold='MuktaBold', sans-serif;" +
  "Muli='MuliRegular', sans-serif;" +
  "Muli Bold='MuliBold', sans-serif;" +
  "Muli Light='MuliLight', sans-serif;" +
  "Nanum Gothic='NanumGothic', sans-serif;" +
  "Nanum Gothic Bold='NanumGothicBold', sans-serif;" +
  "Neue Haas Unica='NeueHaasUnica', sans-serif;" +
  "Neue Haas Unica Bold='NeueHaasUnicaBold', sans-serif;" +
  "Neue Haas Unica Extra Bold='NeueHaasUnicaExtraBold', sans-serif;" +
  "Noe Display='NoeDisplay', serif;" +
  "Noe Display Italic='NoeDisplayItalic', serif;" +
  "Noe Display Medium='NoeDisplayMedium', serif;" +
  "Noe Display Medium Italic='NoeDisplayMediumItalic', serif;" +
  "Noe Display Bold='NoeDisplayBold', serif;" +
  "Noe Display Bold Italic='NoeDisplayBoldItalic', serif;" +
  "Noe Display Black='NoeDisplayBlack', serif;" +
  "Noe Display Black Italic='NoeDisplayBlackItalic', serif;" +
  "Noe Text='NoeText', serif;" +
  "Noe Text Italic='NoeTextItalic', serif;" +
  "Noe Text Book='NoeTextBook', serif;" +
  "Noe Text Book Italic='NoeTextBookItalic', serif;" +
  "Noe Text Semi Bold='NoeTextSemiBold', serif;" +
  "Noe Text Semi Bold Italic='NoeTextSemiBoldItalic', serif;" +
  "Noe Text Bold='NoeTextBold', serif;" +
  "Noe Text Bold Italic='NoeTextBoldItalic', serif;" +
  "Noe Text Black='NoeTextBlack', serif;" +
  "Noe Text Black Italic='NoeTextBlackItalic', serif;" +
  "Noto Sans Light='NotoSansLight', sans-serif;" +
  "Noto Sans='NotoSans', sans-serif;" +
  "Noto Sans Bold='NotoSansBold', sans-serif;" +
  "Noto Sans Black='NotoSansBlack', sans-serif;" +
  "Nunito Light='NunitoLight', sans-serif;" +
  "Nunito='Nunito', sans-serif;" +
  "Nunito Bold='NunitoBold', sans-serif;" +
  "Nunito Black='NunitoBlack', sans-serif;" +
  "Ollies Solid=OlliesSolid, sans-serif;" +
  "Open Sans Light=OpenSansLight;" +
  "Open Sans=OpenSans;" +
  "Open Sans Semi Bold=OpenSansSemiBold;" +
  "Open Sans Bold=OpenSansBold;" +
  "Open Sans Extra Bold=OpenSansExtraBold;" +
  "Oswald Light='OswaldLight', sans-serif;" +
  "Oswald='Oswald', sans-serif;" +
  "Oswald Bold='OswaldBold', sans-serif;" +
  "Oxygen Light='OxygenLight', sans-serif;" +
  "Oxygen='Oxygen', sans-serif;" +
  "Oxygen Bold='OxygenBold', sans-serif;" +
  "Pacifico='Pacifico', cursive;" +
  "Passions Conflict='PassionsConflict',cursive;" +
  "Pathway Gothic One Regular='PathwayGothicOneRegular', sans-serif;" +
  "Pathways Rough Regular='PathwaysRoughRegular', sans-serif;" +
  "Permanent Marker Regular='PermanentMarkerRegular',cursive;" +
  "Pilat Thin='PilatThin', sans-serif;" +
  "Pilat Light='PilatLight', sans-serif;" +
  "Pilat='Pilat', sans-serif;" +
  "Pilat Book='PilatBook', sans-serif;" +
  "Pilat Demi='PilatDemi', sans-serif;" +
  "Pilat Bold='PilatBold', sans-serif;" +
  "Pilat Heavy='PilatHeavy', sans-serif;" +
  "Pilat Black='PilatBlack', sans-serif;" +
  "Pilat Extended Thin='PilatExtendedThin', sans-serif;" +
  "Pilat Extended Light='PilatExtendedLight', sans-serif;" +
  "Pilat Extended='PilatExtended', sans-serif;" +
  "Pilat Extended Book='PilatExtendedBook', sans-serif;" +
  "Pilat Extended Demi='PilatExtendedDemi', sans-serif;" +
  "Pilat Extended Bold='PilatExtendedBold', sans-serif;" +
  "Pilat Extended Heavy='PilatExtendedHeavy', sans-serif;" +
  "Pilat Extended Black='PilatExtendedBlack', sans-serif;" +
  "Pilat Narrow Book='PilatNarrowBook', sans-serif;" +
  "Pilat Narrow Bold='PilatNarrowBold', sans-serif;" +
  "Pilat Narrow Black='PilatNarrowBlack', sans-serif;" +
  "Pipetton Script='PipettonScript', cursive;" +
  "PT Sans='PTSans', sans-serif;" +
  "PT Sans Bold='PTSansBold', sans-serif;" +
  "PT Serif='PTSerif', sans-serif;" +
  "PT Serif Bold='PTSerifBold', sans-serif;" +
  "Playfair Display SC='PlayfairDisplaySC', serif;" +
  "Playfair Display SC Bold='PlayfairDisplaySCBold', serif;" +
  "Playfair Display SC Black='PlayfairDisplaySCBlack', serif;" +
  "Poppins='Poppins', sans-serif;" +
  "Porsche Next TT Thin=PorscheNextTTThin;" +
  "Porsche Next TT Regular=PorscheNextTTRegular;" +
  "Porsche Next TT Bold=PorscheNextTTBold;" +
  "Primark Basis Regular='PrimarkBasisRegular', serif;" +
  "Primark Basis Bold='PrimarkBasisBold', serif;" +
  "Proxima Nova='ProximaNova', sans-serif;" +
  "Proxima Nova Bold='ProximaNovaBold', sans-serif;" +
  "Prosto One='ProstoOne',cursive;" +
  "Questrial Regular='QuestrialRegular', sans-serif;" +
  "Quicksand='Quicksand', sans-serif;" +
  "Raleway Thin='RalewayThin', sans-serif;" +
  "Raleway Extra Light='RalewayExtraLight', sans-serif;" +
  "Raleway Light='RalewayLight', sans-serif;" +
  "Raleway='Raleway', sans-serif;" +
  "Raleway Medium='RalewayMedium', sans-serif;" +
  "Raleway Semi Bold='RalewaySemiBold', sans-serif;" +
  "Raleway Bold='RalewayBold', sans-serif;" +
  "Raleway Extra Bold='RalewayExtraBold', sans-serif;" +
  "Raleway Black='RalewayBlack', sans-serif;" +
  "Raleway Dots='RalewayDots', sans-serif;" +
  "Roboto Thin='RobotoThin', sans-serif;" +
  "Roboto='Roboto', sans-serif;" +
  "Roboto Bold='RobotoBold', sans-serif;" +
  "Roboto Black='RobotoBlack', sans-serif;" +
  "Roboto Condensed Light='RobotoCondensedLight', sans-serif;" +
  "Roboto Condensed='RobotoCondensed', sans-serif;" +
  "Roboto Condensed Bold='RobotoCondensedBold', sans-serif;" +
  "Roboto Slab Bold='RobotoSlabBold', sans-serif;" +
  "Roboto Slab Light='RobotoSlabLight', sans-serif;" +
  "Roboto Slab Regular='RobotoSlabRegular', sans-serif;" +
  "Roboto Slab Thin='RobotoSlabThin', sans-serif;" +
  "Rokkitt Light='RokkittLight', serif;" +
  "Rokkitt='Rokkitt', serif;" +
  "Rokkitt Bold='RokkittBold', serif;" +
  "Rokkitt Black='RokkittBlack', serif;" +
  "Roobert='Roobert', sans-serif;" +
  "Rubik='Rubik', sans-serif;" +
  "Rubik Vinyl='RubikVinyl',cursive;" +
  "Rubik Gemstones='RubikGemstones',cursive;" +
  "Rubik Glitch='RubikGlitch',cursive;" +
  "Rubik Microbe='RubikMicrobe',cursive;" +
  "Rubik Moonrocks='RubikMoonrocks',cursive;" +
  "Rubik Wet Paint='RubikWetPaint',cursive;" +
  "Rund='Rund',sans-serif;" +
  "Rund Medium='RundMedium',sans-serif;" +
  "Rund Black='RundBlack',sans-serif;" +
  "Rund Extra Bold='RundExtraBold',sans-serif;" +
  "Sevillana='Sevillana',cursive;" +
  "Shantell Sans Extra Bold='ShantellSansExtraBold', sans-serif;" +
  "Shantell Sans Medium='ShantellSansMedium', sans-serif;" +
  "Shadows Into Light='ShadowsIntoLight', cursive;" +
  "Signika='Signika', sans-serif;" +
  "Slabo 27px='Slabo27px',sans-serif;" +
  "Sofia Pro Bold='SofiaProBold', sans-serif;" +
  "Sohne Thin='SohneThin';" +
  "Sohne Light='SohneLight';" +
  "Sohne='Sohne';" +
  "Sohne Medium='SohneMedium';" +
  "Sohne Semi Bold='SohneSemiBold';" +
  "Sohne Bold='SohneBold';" +
  "Sohne Extra Bold='SohneExtraBold';" +
  "Sohne Black='SohneBlack';" +
  "Sohne Mono='SohneMono';" +
  "Sohne Mono Medium='SohneMonoMedium';" +
  "Source Code Pro Light='SourceCodeProLight', monospace;" +
  "Source Code Pro='SourceCodePro', monospace;" +
  "Source Code Pro Bold='SourceCodeProBold', monospace;" +
  "Source Sans Pro Light='SourceSansProLight', monospace;" +
  "Source Sans Pro='SourceSansPro', monospace;" +
  "Source Sans Pro Bold='SourceSansProBold', monospace;" +
  "Swear Display Regular='SwearDisplayRegular';" +
  "Tekton Light='TektonLight',sans-serif;" +
  "Tekton='Tekton',sans-serif;" +
  "Tekton Bold='TektonBold',sans-serif;" +
  "Termina Test Bold='TerminaTestBold';" +
  "Termina Test Regular='TerminaTestRegular';" +
  "Tiempos Headline Light='TiemposHeadlineLight', sans-serif;" +
  "Tiempos Headline Semibold='TiemposHeadlineSemibold', sans-serif;" +
  "Tiempos Headline SemiboldItalic='TiemposHeadlineSemiboldItalic', sans-serif;" +
  "Titillium Web Light='TitilliumWebLight',sans-serif;" +
  "Titillium Web='TitilliumWeb',sans-serif;" +
  "Titillium Web Bold='TitilliumWebBold',sans-serif;" +
  "Titillium Web Black='TitilliumWebBlack',sans-serif;" +
  "Trade Gothic Light='Trade Gothic Light',sans-serif;" +
  "Trade Gothic='Trade Gothic',sans-serif;" +
  "Trade Gothic Bold='Trade Gothic Bold',sans-serif;" +
  "Trade Gothic Bold Condensed='Trade Gothic Bold Condensed',sans-serif;" +
  "Ubuntu Light='UbuntuLight';" +
  "Ubuntu='Ubuntu';" +
  "Ubuntu Medium='UbuntuMedium';" +
  "Ubuntu Bold='UbuntuBold';" +
  "Varela Round='VarelaRound', serif;" +
  "Vollkorn='Vollkorn', serif;" +
  "Vollkorn Bold='VollkornBold', serif;" +
  "Whitney Light='WhitneyLight', serif;" +
  "Whitney Medium='WhitneyMedium', serif;" +
  "Whitney='Whitney', serif;" +
  "Whitney Book='WhitneyBook', serif;" +
  "Whitney Semi Bold='WhitneySemiBold', serif;" +
  "Whitney Bold='WhitneyBold', serif;" +
  "Whitney Black='WhitneyBlack', serif;" +
  "Work Sans Light='WorkSansLight', serif;" +
  "Work Sans='WorkSans', serif;" +
  "Work Sans Bold='WorkSansBold', serif;" +
  "Yanone Kaffeesatz Light='YanoneKaffeesatzLight', sans-serif;" +
  "Yanone Kaffeesatz='YanoneKaffeesatz', sans-serif;" +
  "Yanone Kaffeesatz Bold='YanoneKaffeesatzBold', sans-serif;" +
  "Yorkten Slab='YorktenSlab', sans-serif;" +
  "Zodiak Thin='ZodiakThin', sans-serif;" +
  "Zodiak Light='ZodiakLight', sans-serif;" +
  "Zodiak='Zodiak', sans-serif;" +
  "Zodiak Bold='ZodiakBold', sans-serif;" +
  "Zodiak Extra Bold='ZodiakExtraBold', sans-serif;" +
  "Zodiak Black='ZodiakBlack', sans-serif;";

// Hardcoded while we are moving to new Editor 
const PRIVATE_FONTS_USER_ID = "09c57e2924a5fed3589fbb9feaf9a027";
const _privateFonts = [
  { name: "Alte Haas Grotesk", format: "AlteHaasGrotesk" },
  { name: "Bootzy TM Regular", format: "BootzyTMRegular" },
];

const _privateFontsEditor =
  "Alte Haas Grotesk='AlteHaasGrotesk', sans-serif;" +
  "Bootzy TM Regular='BootzyTMRegular', sans-serif;";

const _resolveUserIdFromUrl = () => {
  if (typeof window === "undefined" || !window.location) return null;
  try {
    return new URLSearchParams(window.location.search).get("u");
  } catch (_) {
    return null;
  }
};

const _isPrivateFontsUser = _resolveUserIdFromUrl() === PRIVATE_FONTS_USER_ID;

export const googleFonts = _isPrivateFontsUser
  ? [..._baseGoogleFonts, ..._privateFonts]
  : _baseGoogleFonts;

export const googleFontsEditor = _isPrivateFontsUser
  ? _baseGoogleFontsEditor + _privateFontsEditor
  : _baseGoogleFontsEditor;
